import { ref, onMounted } from "vue";
const isReducedMotion = ref(false);
const detectReducedMotionMode = () => {
  isReducedMotion.value = window.matchMedia(`(prefers-reduced-motion: reduce)`).matches;
};
const useReducedMotion = () => {
  onMounted(() => {
    detectReducedMotionMode();
  });
  return isReducedMotion;
};
export {
  detectReducedMotionMode,
  isReducedMotion,
  useReducedMotion
};
